import axios from 'axios';
import { baseUrl, HttpMethods } from '../../../../base';
import type {
  IGetProjectAuditsService,
  IGetProjectPhasesServiceRes,
  IGetProjectService,
  IGetProjectServiceRes,
  IPatchArchiveProjectService,
  IPatchProjectService,
  IPatchUnarchiveProjectService,
  IPostImportProjectsService,
  IPostProjectService,
} from './types';

export async function getProject({ projectId, params }: IGetProjectService): Promise<IGetProjectServiceRes> {
  const res = await axios.request<IGetProjectServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/projects/${projectId}`,
    params,
  });
  return res.data;
}

export async function postProject({ data }: IPostProjectService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects`,
    data,
  });
  return res.data;
}

export async function patchProject({ projectId, data }: IPatchProjectService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/projects/${projectId}`,
    data,
  });
  return res.data;
}

export async function getProjectPhases(): Promise<IGetProjectPhasesServiceRes> {
  const res = await axios.request<IGetProjectPhasesServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/phases`,
  });
  return res.data;
}

export async function getProjectAudit({ params }: IGetProjectAuditsService) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/audits`,
    params,
  });
  return res.data;
}

export async function patchArchiveProject({ projectId }: IPatchArchiveProjectService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/projects/${projectId}/archive`,
  });
  return res.data;
}

export async function patchUnarchiveProject({ projectId }: IPatchUnarchiveProjectService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/projects/${projectId}/unarchive`,
  });
  return res.data;
}

export async function postImportProjects({ data }: IPostImportProjectsService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects/import`,
    data,
  });
  return res.data;
}
